import React from 'react'
import MaterialSymbol from '../material-symbol'

const ArrowUpward = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="arrow_upward" {...props} />
))

ArrowUpward.displayName = 'ArrowUpward'

export default ArrowUpward
